export const CONNECT_CLAIM_TOKEN_PATTERN = /^[A-Za-z0-9_-]{32}$/;
//# sourceMappingURL=connect-claim.js.map